import { useState, useEffect } from 'react';
import css from './CourseOverview.module.css';

import * as courseServices from '../../../../../services/courseServices';

import CourseTable from './CourseTable';
import ModalForm from '../../../_common/ModalForm';
import AddNewCourse from './AddNewCourse';
import PlusButton from '../../../_common/elements/PlusButton';

function CourseOverview() {
    const [courses, setCourses] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        courseServices
            .getAll(page || 1)
            .then((result) => {
                setCourses((state) => result.data.sort((a, b) => b.ID-a.ID) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [showModal]);

    const onAdd = (newData) => {
        setCourses((state) => [
            {
                ID: newData.courseNo,
                Title: newData.courseTitle,
                Type: '',
                Start: newData.courseStart,
                End: newData.courseEnd,
                Status: 'Acquisition',
            },
            ...state,
        ]);
    };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);

    //Provides the start of the link for the details
    const detailsTo = '/course/details/';

    return (
        <div className={css.main}>
            <div>
                <CourseTable data={courses} detailsTo={detailsTo} />
            </div>
            <div>
                <div>
                    <PlusButton onClick={toggleModal} />
                    <ModalForm showModal={showModal}>
                        <AddNewCourse data={courses} onAdd={onAdd} toggleModal={toggleModal} />
                    </ModalForm>
                </div>
                <></>
            </div>
        </div>
    );
}

export default CourseOverview;

